import mitt from 'mitt';
var emitter = mitt();
export var registerEvent = function registerEvent(eventName, callback) {
  emitter === null || emitter === void 0 ? void 0 : emitter.on(eventName, callback);
};
export var emitEvent = function emitEvent(eventName, data) {
  emitter === null || emitter === void 0 ? void 0 : emitter.emit(eventName, data);
};
export var unregisterEvent = function unregisterEvent(eventName, callback) {
  emitter === null || emitter === void 0 ? void 0 : emitter.off(eventName, callback);
};